import { defineComponent as _defineComponent } from 'vue';
import { ref } from "vue";
import { useDetailedDatatypes } from "@/composables/datatypes";
import { useFilterObjectArray } from "@/composables/utils/filter";
import DelayedInput from "@/components/Common/DelayedInput.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AvailableDatatypes',
    setup(__props) {
        const filter = ref("");
        const filterFields = ["extension"];
        const { datatypes } = useDetailedDatatypes();
        const filteredDatatypes = useFilterObjectArray(datatypes, filter, filterFields);
        const fields = [
            {
                key: "extension",
                sortable: true,
            },
            {
                key: "edamFormatLabel",
                label: "EDAM Format",
                sortable: true,
            },
            {
                key: "edamDataLabel",
                label: "EDAM Data",
                sortable: true,
            },
        ];
        const edamLink = (edamIRI) => `https://edamontology.github.io/edam-browser/#${edamIRI}`;
        return { __sfc: true, filter, filterFields, datatypes, filteredDatatypes, fields, edamLink, DelayedInput };
    }
});
